import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, user } = useAuth();
  const { t } = useTranslation('common');

  // Hide Navigation when user is authenticated
  if (isAuthenticated && user) {
    return null;
  }

  return (
    <nav className="fixed top-0 w-full z-50 border-b shadow-md" style={{ backgroundColor: '#0F2915', borderBottomColor: 'rgba(212, 175, 55, 0.2)' }}>
      <div className="max-w-container-max mx-auto px-margin-mobile py-4 flex justify-between items-center">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="hover:opacity-80 transition-opacity md:hidden"
          style={{ color: '#D4AF37' }}
          aria-label="Menu"
        >
          <span className="material-symbols-outlined">menu</span>
        </button>

        <Link to="/" className="hover:opacity-80 transition-opacity flex items-center gap-2" title="Wellis Home">
          <img
            src="/images/wellis-logo.png"
            alt="Wellis"
            className="h-12 w-auto"
          />
          <span className="text-headline-lg font-bold uppercase tracking-widest hidden sm:inline" style={{ color: '#D4AF37' }}>
            WELLIS
          </span>
        </Link>

        <div className="hidden md:flex gap-8 items-center">
          <Link to="/products" className="text-body-md hover:opacity-80 transition-opacity" style={{ color: '#D4AF37' }}>{t('footer.products')}</Link>
          <Link to="/marketing-plan" className="text-body-md hover:opacity-80 transition-opacity" style={{ color: '#D4AF37' }}>{t('nav.marketingPlan')}</Link>
          <Link to="/about" className="text-body-md hover:opacity-80 transition-opacity" style={{ color: '#D4AF37' }}>{t('footer.about')}</Link>
          <Link to="/contact" className="text-body-md hover:opacity-80 transition-opacity" style={{ color: '#D4AF37' }}>{t('footer.contact')}</Link>
        </div>

        <div className="flex gap-4 items-center">
          <LanguageSwitcher />
          <div className="flex gap-2">
            <Link to="/login" className="hover:opacity-80 transition-opacity px-4 py-2 rounded-lg text-body-sm font-medium" style={{ color: '#D4AF37', border: '2px solid #D4AF37' }}>
              {t('auth.login')}
            </Link>
            <Link to="/signup" className="hover:opacity-80 transition-opacity px-4 py-2 rounded-lg text-body-sm font-medium" style={{ color: '#0F2915', backgroundColor: '#D4AF37' }}>
              {t('auth.signup')}
            </Link>
          </div>
        </div>

        {isOpen && (
          <div className="absolute top-full left-0 right-0 backdrop-blur-md md:hidden border-t shadow-lg" style={{ backgroundColor: 'rgba(15, 41, 21, 0.98)', borderTopColor: 'rgba(212, 175, 55, 0.2)' }}>
            <div className="flex flex-col gap-4 p-4">
              <Link to="/products" className="text-body-md hover:opacity-80" style={{ color: '#D4AF37' }} onClick={() => setIsOpen(false)}>{t('footer.products')}</Link>
              <Link to="/marketing-plan" className="text-body-md hover:opacity-80" style={{ color: '#D4AF37' }} onClick={() => setIsOpen(false)}>{t('nav.marketingPlan')}</Link>
              <Link to="/about" className="text-body-md hover:opacity-80" style={{ color: '#D4AF37' }} onClick={() => setIsOpen(false)}>{t('footer.about')}</Link>
              <Link to="/contact" className="text-body-md hover:opacity-80" style={{ color: '#D4AF37' }} onClick={() => setIsOpen(false)}>{t('footer.contact')}</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
